export const property = (description) => {
  return Symbol(description);
};
